import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
import { AuthOptions, createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import awsconfig from "../amplifyconfiguration.json";

Amplify.configure(awsconfig);

const authConfig = {
  url: awsconfig.aws_appsync_graphqlEndpoint,
  region: awsconfig.aws_appsync_region,
  auth: {
    type: "AWS_IAM" as const,
    credentials: async () => (await fetchAuthSession()).credentials!,
  } satisfies AuthOptions,
};

// Create subscription and auth links
const authLink = createAuthLink(authConfig);
const subscriptionLink = createSubscriptionHandshakeLink(authConfig);

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, subscriptionLink]),
  cache: new InMemoryCache(),
  enhancedClientAwareness: { transport: false },
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
    },
  },
});
